module.exports = __webpack_public_path__ + "a5fffb35e61c01bb6ebc447097d27738.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/microphone.png
// module id = 2407
// module chunks = 0